import type { AttachmentDto } from '@private-messenger/shared';

export function quotedMessagePreview(
  message: {
    text: string;
    attachments: AttachmentDto[];
    deletedAt?: string | null;
  },
  attachmentId?: string | null,
): string {
  if (message.deletedAt) return 'Сообщение удалено';
  const selectedAttachment = attachmentId
    ? message.attachments.find((attachment) => attachment.id === attachmentId)
    : null;
  if (selectedAttachment) {
    if (selectedAttachment.mimeType.startsWith('audio/')) return '🎤 Голосовое сообщение';
    if (selectedAttachment.mimeType.startsWith('image/')) {
      return `📷 ${selectedAttachment.originalName || 'Фотография'}`;
    }
    return `📎 ${selectedAttachment.originalName || 'Файл'}`;
  }
  const text = message.text.trim().replace(/\s+/g, ' ');
  if (text) return text;
  if (message.attachments.length === 0) return 'Сообщение';
  if (message.attachments.every((attachment) => attachment.mimeType.startsWith('audio/'))) {
    return '🎤 Голосовое сообщение';
  }
  const imageCount = message.attachments.filter((attachment) =>
    attachment.mimeType.startsWith('image/'),
  ).length;
  if (imageCount === message.attachments.length) {
    return imageCount === 1 ? '📷 Фотография' : `📷 Фотографии: ${imageCount}`;
  }
  if (message.attachments.length === 1) {
    return `📎 ${message.attachments[0]?.originalName ?? 'Файл'}`;
  }
  return `📎 Вложения: ${message.attachments.length}`;
}
